import { Text, View, Link } from '@react-pdf/renderer';

// Icons
import { PDFLinkIcon } from '@/components/pdf-icons';

// Utils
import { hasValidCertification, formatDayMonthYearLabel } from '@shared/utils';
import { getPDFCertificationIcon } from '@/utils/icons';

// Types
import { FormCertification } from '@shared/types';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

// Styles
import styles from '../../style';
interface CertificatesSectionProps {
  certs: FormCertification[];
}
const CertificatesSection = ({
  certs
}: CertificatesSectionProps) => {
  if (!certs || !hasValidCertification(certs)) return null;
  return <View style={[styles.sectionContainer, {
    marginTop: 8
  }]} data-sentry-element="View" data-sentry-component="CertificatesSection" data-sentry-source-file="Certificates.tsx">
      <View style={[styles.divider, {
      marginBottom: 8,
      marginTop: 0
    }]} data-sentry-element="View" data-sentry-source-file="Certificates.tsx" />

      <Text style={styles.sectionTitle} data-sentry-element="Text" data-sentry-source-file="Certificates.tsx">{SECTION_TITLES.certifications}</Text>

      {certs.map((cert, index) => {
      const {
        name = '',
        issue = '',
        url = '',
        org = ''
      } = cert || {};
      const Icon = getPDFCertificationIcon(org);
      return <View key={`certification-${index}`} style={styles.certificationItem}>
            <View style={styles.certificationHeader} break>
              <View style={styles.certificationLogo}>
                <Icon />
              </View>

              <View style={styles.certificationNameContainer}>
                <Text style={styles.certificationName}>{name || ' '}</Text>

                <View style={styles.certificationMetaContent}>
                  <Text style={styles.certificationDate}>
                    {issue && <>Issued {formatDayMonthYearLabel(issue)}</>}
                  </Text>

                  {url && <Link src={url} style={styles.certificationLink}>
                      <PDFLinkIcon />
                    </Link>}
                </View>
              </View>
            </View>
          </View>;
    })}
    </View>;
};
export default CertificatesSection;